import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { Stack, Typography } from "@mui/material"

import type { EntityType } from "types/common.types"
import type { CsvDateRange } from "types/csv.types"
import CsvDatePicker from "./CsvDatePicker"

interface CsvDateRangeSectionProps {
  entity: EntityType
  value: CsvDateRange | null
  maxRangeMonths: number
  onChange: (value: CsvDateRange) => void
}

const CsvDateRangeSection: FC<CsvDateRangeSectionProps> = ({
  entity,
  value,
  maxRangeMonths,
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <Stack spacing={1} alignItems="flex-start">
      {value && (
        <CsvDatePicker
          value={value}
          onChange={onChange}
          entity={entity}
          maxRangeMonths={maxRangeMonths}
        />
      )}
      <Typography
        variant="caption"
        sx={{ color: (theme) => theme.palette.text.secondary }}
      >
        {t("csv_drawer.MAX_RANGE", { count: maxRangeMonths })}
      </Typography>
    </Stack>
  )
}

export default CsvDateRangeSection
